<template>
  <div class="centCommissionDetails">
    <van-sticky>
      <div
        class="centCommissionDetailsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">结算详情</span>
      </div>
    </van-sticky>
    <div class="content">
      <div class="cardTop">
        <p>结算金额</p>
        <h3>¥{{ data.amount }}</h3>
        <div class="line"></div>
        <!-- <div class="item">
          <p>结算方式</p>
          <span v-if="is_agent">{{
            data.is_online == 1 ? "线上结算" : "线下结算"
          }}</span>
          <span v-else>{{ data.is_online_name }}</span>
        </div> -->
        <div class="item">
          <p>结算时间</p>
          <span>{{ data.commission_at }}</span>
        </div>
        <div class="item">
          <p>结算比例</p>
          <span v-if="is_agent"
            >{{
              data.order ? (data.order.agent_rate * 10000) / 100 : "-"
            }}%</span
          >
          <span v-else
            >{{
              data.order ? (data.order.partner_rate * 10000) / 100 : "-"
            }}%</span
          >
        </div>
      </div>
      <!-- 代理人 -->
      <div class="card" v-if="is_agent">
        <h3>关联订单</h3>
        <div class="item">
          <p>订单编号：</p>
          <span>{{ data.order ? data.order.order_sn : "" }}</span>
          <img
            @click="copy()"
            id="copycode"
            :data-clipboard-text="data.order ? data.order.order_sn : ''"
            src="./../../../assets/decoration/copy.png"
            alt=""
          />
        </div>
        <div class="item">
          <p>用户信息：</p>
          <span>{{ data.member_name }} {{ data.phone | phoneEncryption }}</span>
        </div>
        <div class="item">
          <p>订单金额：</p>
          <span>￥{{ data.order ? data.order.amount : "" }}</span>
        </div>
        <div class="item">
          <p>支付时间：</p>
          <span>{{ data.order ? data.order.pay_time : "" }}</span>
        </div>
      </div>
      <!-- 合伙人 -->
      <div class="card" v-else>
        <h3>关联订单</h3>
        <div class="item">
          <p>订单编号：</p>
          <span>{{ data.order_sn }}</span>
          <img
            @click="copy()"
            id="copycode"
            :data-clipboard-text="data.order_sn"
            src="./../../../assets/decoration/copy.png"
            alt=""
          />
        </div>
        <div class="item">
          <p>订单地址：</p>
          <span
            >{{ data.order ? data.order.province_city_area : ""
            }}{{ data.order ? data.order.address : "" }}</span
          >
        </div>
        <div class="item">
          <p>用户信息：</p>
          <span
            >{{ data.order ? data.order.member_name : "" }}
            {{
              data.order ? data.order.member_phone : "" | phoneEncryption
            }}</span
          >
        </div>
        <div class="item">
          <p>订单金额：</p>
          <span>￥{{ data.order ? data.order.amount : "" }}</span>
        </div>
        <div class="item">
          <p>下单时间：</p>
          <span>{{ data.order ? data.order.created_at : "" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  data() {
    return {
      isiOSX: false,
      commission_id: null,
      data: {},
      is_agent: true,
    };
  },
  filters: {
    phoneEncryption(value) {
      if (value) {
        return value.substring(0, 3) + "****" + value.substring(3 + 4);
      }
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.is_agent = JSON.parse(this.$route.query.is_agent);
    if (this.$route.query.commission_id) {
      this.commission_id = this.$route.query.commission_id;
    }
    this.getData();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取详情
    getData() {
      if (this.is_agent) {
        this.$api
          .get("decoration/member/city/agent/commiss/show", {
            agent_commission_id: this.commission_id,
          })
          .then((res) => {
            this.data = res;
          });
      } else {
        this.$api
          .post("decoration/member/city/partner/order/commissions/show", {
            commission_id: this.commission_id,
          })
          .then((res) => {
            this.data = res;
          });
      }
    },
    copy() {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less">
.centCommissionDetails {
  height: 100%;
  background: #f5f6ff;
  .centCommissionDetailsNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 0 16px;
    .cardTop {
      background: #ffffff;
      border-radius: 12px;
      margin: 12px 0;
      padding: 24px;
      color: #333333;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        color: #999999;
        font-size: 14px;
        margin-top: 6px;
      }
      h3 {
        font-size: 24px;
        line-height: 33px;
        margin: 16px 0 32px;
      }
      .line {
        width: 100%;
        height: 1px;
        background-color: #f0f1ff;
        margin-bottom: 12px;
      }
      .item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
        p,
        span {
          font-size: 15px;
        }
      }
    }
    .card {
      background: #ffffff;
      border-radius: 12px;
      padding: 24px;
      h3 {
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        margin: 0 0 4px;
      }
      .item {
        display: flex;
        // align-items: center;
        margin-top: 16px;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        img {
          width: 16px;
          height: 16px;
          margin-left: 6px;
          margin-top: 3px;
        }
        p {
          color: #999999;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>